/*!
 * Zimshy Core - offers engine + UI helpers for the Kalles based Zimshy theme.
 * - Free gift (choose 1, radio buttons) unlocked at a cart total, auto-removed below it
 * - Order discount progress (e.g. 10% over Rs.5,000), optional code applied at checkout
 * - Product page gift picker, cart drawer + cart page offer panels
 * - Scroll carousels, WhatsApp-style voice notes, screenshot lightbox, countdowns, quick add, copy buttons
 * No libraries. Works with or without jQuery. Loaded with defer from layout/theme.liquid.
 */
(function () {
  'use strict';
  if (window.ZP && window.ZP.__ready) return;

  var C = window.ZimshyOffers || {};
  var G = C.gift || { enabled: false, items: [] };
  var D = C.disc || { enabled: false };
  var ROOT = C.root || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var ZP = window.ZP = window.ZP || {};
  ZP.__ready = true;

  /* ------------------------------------------------------------------ utils */
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(v) { v = Number(v); return isFinite(v) ? v : 0; }

  function money(cents) {
    var fmt = String(C.moneyFormat || 'Rs.{{amount}}').replace(/<[^>]*>/g, '');
    cents = Math.round(num(cents));
    function f(dec, thou, decSep) {
      var s = (Math.abs(cents) / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      var out = s.length > 1 ? s[0] + decSep + s[1] : s[0];
      out = out.replace(/[.,]00$/, ''); // same look as money_without_trailing_zeros
      return (cents < 0 ? '-' : '') + out;
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount', val;
    switch (key) {
      case 'amount_no_decimals': val = f(0, ',', '.'); break;
      case 'amount_with_comma_separator': val = f(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = f(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = f(2, "'", '.'); break;
      default: val = f(2, ',', '.');
    }
    return m ? fmt.replace(m[0], val) : val;
  }
  ZP.money = money;
  ZP.esc = esc;

  var store = {
    get: function (k) { try { return window.sessionStorage.getItem('zp_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem('zp_' + k, v); } catch (e) {} },
    del: function (k) { try { window.sessionStorage.removeItem('zp_' + k); } catch (e) {} }
  };

  function api(path, body) {
    var opts = {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    if (!body) opts.cache = 'no-store';
    return nativeFetch(ROOT + path, opts).then(function (r) {
      return r.text().then(function (t) {
        var d = {};
        try { d = t ? JSON.parse(t) : {}; } catch (e) { d = {}; }
        if (!r.ok || (d && d.status && Number(d.status) >= 400)) {
          var err = new Error((d && (d.description || d.message)) || 'Something went wrong. Please try again.');
          err.data = d;
          throw err;
        }
        return d;
      });
    });
  }
  ZP.api = api;
  // Compare-at prices per variant. Seeded from the page, filled from /products/<handle>.js when missing,
  // so pack savings never disappear even if the cart data comes from the standard /cart.js.
  var VCMP = {}, PJS = {};
  ((C.cart && C.cart.items) || []).forEach(function (l) { if (l.compare_at != null) VCMP[String(l.variant_id)] = num(l.compare_at); });
  function productJs(handle) {
    if (!handle) return Promise.resolve(null);
    if (!PJS[handle]) {
      PJS[handle] = nativeFetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          ((p && p.variants) || []).forEach(function (v) { VCMP[String(v.id)] = num(v.compare_at_price); });
          return p;
        })
        .catch(function () { return null; });
    }
    return PJS[handle];
  }
  // Bring any cart payload (zpsave view or /cart.js) to one shape: compare_at, cart_disc, codes.
  function normalize(cart) {
    cart = cart || { items: [] };
    if (cart.cart_disc == null) {
      cart.cart_disc = ((cart.cart_level_discount_applications) || []).reduce(function (a, d) { return a + num(d.total_allocated_amount); }, 0);
    }
    if (!cart.codes) {
      if (cart.discount_codes) cart.codes = cart.discount_codes.map(function (d) { return { code: d.code, applicable: d.applicable !== false }; });
      else cart.codes = ((cart.cart_level_discount_applications) || []).filter(function (d) { return d.type === 'discount_code'; })
        .map(function (d) { return { code: d.title || d.key, applicable: true }; });
    }
    var missing = [];
    (cart.items || []).forEach(function (l) {
      if (l.compare_at != null) { VCMP[String(l.variant_id)] = num(l.compare_at); return; }
      if (VCMP[String(l.variant_id)] == null && l.handle) missing.push(l.handle);
    });
    return Promise.all(missing.filter(function (h, i) { return missing.indexOf(h) === i; }).map(productJs)).then(function () {
      (cart.items || []).forEach(function (l) {
        if (l.compare_at == null) l.compare_at = num(VCMP[String(l.variant_id)]);
        if (l.original_price == null && l.original_line_price != null) l.original_price = num(l.original_line_price) / Math.max(1, num(l.quantity));
      });
      return cart;
    });
  }
  // Cart with compare-at prices (templates/cart.zpsave.liquid); falls back to /cart.js + product data
  function fetchCart() {
    return nativeFetch(ROOT + 'cart?view=zpsave', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('view'); return r.text(); })
      .then(function (t) { var d = JSON.parse(t); if (!d || !d.items) throw new Error('view'); return d; })
      .catch(function () { return api('cart.js'); })
      .then(normalize);
  }
  ZP.getCart = fetchCart;
  ZP.addItems = function (items) { return api('cart/add.js', { items: items }); };

  /* toast */
  var toastEl, toastT;
  function toast(msg, type) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'zp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.className = 'zp-toast is-on' + (type ? ' zp-toast--' + type : '');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.className = 'zp-toast'; }, 3600);
  }
  ZP.toast = toast;

  /* ------------------------------------------------------- theme bridges */
  function jq() { return window.jQuery || window.$ && window.$.fn && window.$; }

  function setCounts(n) {
    $$('.jsccount').forEach(function (el) { el.textContent = n; });
  }

  // Ask Kalles to re-render the cart drawer / cart page. Kalles only re-renders when the
  // count changed, so the badge is blanked first to force it.
  function refreshTheme() {
    var g = window.geckoShopify;
    if (g && typeof g.onCartUpdate === 'function') {
      $$('.jsccount').forEach(function (el) { el.textContent = '…'; });
      try { g.onCartUpdate(0, 1); return; } catch (e) {}
    }
    if (C.page === 'cart') { window.location.reload(); return; }
    if (S.cart) setCounts(S.cart.item_count);
  }
  ZP.refreshTheme = refreshTheme;

  function openCart() {
    var canvas = document.getElementById('nt_cart_canvas');
    var $j = jq();
    if (canvas && $j) {
      var btn = $j('.push_side[data-id="#nt_cart_canvas"]').first();
      if (btn.length) { setTimeout(function () { btn.trigger('click'); }, 60); return; }
    }
    window.location.href = ROOT + 'cart';
  }
  ZP.openCart = openCart;

  /* ------------------------------------------------------- gift helpers */
  var GIFT = {};
  (G.items || []).forEach(function (g) { GIFT[String(g.vid)] = g; });
  function giftById(vid) { return GIFT[String(vid)] || null; }
  function isGiftLine(l) {
    return !!((l.properties && l.properties._zimshy_gift) || GIFT[String(l.variant_id)]);
  }
  function giftLines(cart) { return ((cart && cart.items) || []).filter(isGiftLine); }
  // Part of a line's discount that comes from our order code (Shopify may spread an order code over the lines).
  function codeAlloc(l) {
    var lc = String(D.code || '').trim().toLowerCase();
    if (!lc) return 0;
    return ((l && l.line_level_discount_allocations) || []).reduce(function (a, x) {
      var t = String((x.discount_application && (x.discount_application.title || x.discount_application.key)) || '').toLowerCase();
      return t === lc ? a + num(x.amount) : a;
    }, 0);
  }
  // Cart value used for the gift and 10% thresholds: after product discounts, BEFORE the order code.
  function subtotal(cart) {
    return ((cart && cart.items) || []).reduce(function (s, l) {
      return isGiftLine(l) ? s : s + num(l.final_line_price) + codeAlloc(l);
    }, 0);
  }
  function giftOn() { return !!(G.enabled && G.items && G.items.length); }
  ZP.subtotal = subtotal;
  ZP.isGiftLine = isGiftLine;
  ZP.gifts = function () { return (G.items || []).slice(); };
  ZP.config = C;

  /* --------------------------------------------------------------- engine */
  var S = ZP.state = {
    cart: C.cart || { item_count: 0, items: [] },
    pending: null,
    chain: Promise.resolve(),
    lastGiftVid: null
  };
  var firstGift = giftLines(S.cart)[0];
  S.lastGiftVid = firstGift ? String(firstGift.variant_id) : null;

  ZP.setPending = function (vid) {
    S.pending = vid ? String(vid) : null;
    if (vid) { store.set('choice', String(vid)); store.del('declined'); }
  };

  function enforce(cart) {
    if (!giftOn()) return Promise.resolve(cart);
    var gl = giftLines(cart);
    var ok = subtotal(cart) >= num(G.threshold);
    var updates = {}, hasUpdates = false, toAdd = null, msg = null;

    if (!ok) {
      if (gl.length) {
        gl.forEach(function (l) { updates[l.key] = 0; });
        hasUpdates = true;
        store.set('auto_removed', '1');
        msg = 'Free gift removed. Add ' + money(num(G.threshold) - subtotal(cart)) + ' more to get it back.';
      }
      S.pending = null;
    } else {
      // Shopper removed the gift themselves: respect it until they pick one again.
      if (!gl.length && S.lastGiftVid && !S.pending) store.set('declined', '1');

      gl.forEach(function (l, i) {
        if (i > 0) { updates[l.key] = 0; hasUpdates = true; }
        else if (l.quantity > 1) { updates[l.key] = 1; hasUpdates = true; }
      });

      var want = S.pending;
      if (!want && !gl.length && G.readd && store.get('auto_removed') && !store.get('declined')) {
        want = store.get('choice');
      }
      if (want && giftById(want)) {
        if (!gl.length) toAdd = want;
        else if (String(gl[0].variant_id) !== String(want)) {
          updates[gl[0].key] = 0; hasUpdates = true; toAdd = want;
        }
      }
      S.pending = null;
    }

    if (!hasUpdates && !toAdd) return Promise.resolve(cart);

    var p = Promise.resolve();
    if (hasUpdates) p = p.then(function () { return api('cart/update.js', { updates: updates }); });
    if (toAdd) {
      p = p.then(function () {
        return api('cart/add.js', { items: [{ id: Number(toAdd), quantity: 1, properties: { _zimshy_gift: '1' } }] })
          .then(function () {
            store.set('choice', String(toAdd));
            store.del('auto_removed');
            store.del('declined');
            var g = giftById(toAdd);
            msg = 'FREE gift added: ' + (g ? g.title : 'your gift');
          })
          .catch(function (e) {
            store.del('choice');
            msg = (e && e.message) ? e.message : 'That gift is not available. Please choose another one.';
          });
      });
    }
    return p.then(function () { return fetchCart(); }).then(function (c) {
      if (msg) toast(msg, toAdd ? 'ok' : null);
      refreshTheme();
      return c;
    });
  }

  // Order discount code (e.g. Order10): put it on the cart when the cart qualifies, take it off when it no longer does.
  // Uses Shopify's cart discount API, so the discount shows in the cart AND as a line at checkout.
  function syncCode(cart) {
    var code = String(D.code || '').trim();
    if (!D.enabled || !code || !cart || !cart.codes) return Promise.resolve(cart);
    var codes = cart.codes.map(function (c) { return String(c.code || ''); }).filter(Boolean);
    var lc = code.toLowerCase();
    var has = codes.some(function (c) { return c.toLowerCase() === lc; });
    var others = codes.filter(function (c) { return c.toLowerCase() !== lc; });
    var ok = cart.item_count > 0 && subtotal(cart) >= num(D.threshold);
    var next = null;
    if (ok && !has && !others.length) next = code;                 // never replace a code the shopper typed
    else if (!ok && has) next = others.join(',');                    // '' removes it
    if (next === null) return Promise.resolve(cart);
    return api('cart/update.js', { discount: next })
      .then(function () { return fetchCart(); })
      .then(function (c) { refreshTheme(); return c; })
      .catch(function () { return cart; });
  }

  function run() {
    return fetchCart()
      .then(enforce)
      .then(syncCode)
      .then(function (cart) {
        S.cart = cart;
        var g = giftLines(cart)[0];
        S.lastGiftVid = g ? String(g.variant_id) : null;
        render();
        return cart;
      })
      .catch(function () { render(); return S.cart; });
  }
  ZP.reconcile = function () { S.chain = S.chain.then(run, run); return S.chain; };

  var schedT;
  ZP.schedule = function () {
    clearTimeout(schedT);
    schedT = setTimeout(ZP.reconcile, 350);
  };

  ZP.chooseGift = function (vid) {
    if (!giftById(vid)) return Promise.resolve();
    ZP.setPending(vid);
    return ZP.reconcile();
  };

  /* watch every cart change made by the theme or apps */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?\b/;
  if (window.fetch && !window.__zpFetchPatched) {
    window.__zpFetchPatched = true;
    var pf = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = pf.apply(this, arguments);
      if (CART_RE.test(url)) p.then(function () { ZP.schedule(); }, function () {});
      return p;
    };
  }
  if (window.XMLHttpRequest && !window.__zpXhrPatched) {
    window.__zpXhrPatched = true;
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__zpUrl = u; return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (CART_RE.test(String(this.__zpUrl || ''))) this.addEventListener('loadend', function () { ZP.schedule(); });
      return xs.apply(this, arguments);
    };
  }
  function bindJq() {
    var $j = jq();
    if (!$j || bindJq.done) return;
    bindJq.done = true;
    $j(document.body).on('CartUpdateSuccess CartChangeSuccess', function () { ZP.schedule(); });
  }

  /* ------------------------------------------------------- offer panels */
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function bar(pct) {
    pct = Math.max(0, Math.min(100, pct));
    return '<span class="zp-bar" aria-hidden="true"><span style="width:' + pct.toFixed(1) + '%"></span></span>';
  }
  var GIFT_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>';
  var TAG_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><circle cx="7" cy="7" r="1.5"/></svg>';
  var LOCK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';

  function giftOptions(name, selected, locked, compact) {
    return '<div class="zp-gifts' + (compact ? ' zp-gifts--compact' : '') + (locked ? ' is-locked' : '') + '" role="radiogroup" aria-label="' + esc(G.heading || 'Free gift') + '">' +
      G.items.map(function (g) {
        var id = name + '-' + g.vid;
        var on = String(selected) === String(g.vid);
        return '<label class="zp-gift' + (on ? ' is-on' : '') + '" for="' + id + '">' +
          '<input type="radio" form="zp-detached" id="' + id + '" name="' + name + '" value="' + g.vid + '"' + (on ? ' checked' : '') + (locked ? ' disabled' : '') + '>' +
          '<span class="zp-gift__dot" aria-hidden="true"></span>' +
          (g.img ? '<img src="' + esc(g.img) + '" width="56" height="56" loading="lazy" alt="">' : '<span class="zp-gift__ph">' + GIFT_SVG + '</span>') +
          '<span class="zp-gift__txt"><span class="zp-gift__t">' + esc(g.title) + '</span>' +
          '<span class="zp-gift__p">' + (num(g.worth) > 0 ? '<s>' + money(g.worth) + '</s> ' : '') + '<b>FREE</b></span></span>' +
          (locked ? '<span class="zp-gift__lock">' + LOCK_SVG + '</span>' : '') +
          '</label>';
      }).join('') + '</div>';
  }

  function codeInCart(cart) {
    var lc = String(D.code || '').toLowerCase();
    return !!(lc && cart && cart.codes && cart.codes.some(function (c) { return String(c.code || '').toLowerCase() === lc; }));
  }
  function savings(cart) {
    var items = (cart && cart.items) || [];
    var pack = 0, line = 0, gift = 0, codeLine = 0;
    items.forEach(function (l) {
      var q = num(l.quantity);
      if (isGiftLine(l)) {
        var g = giftById(l.variant_id);
        gift += (num(l.compare_at) || (g ? num(g.worth) : 0)) * q;
        return;
      }
      var op = num(l.original_price) || (num(l.original_line_price) / Math.max(q, 1));
      var fp = l.final_price != null ? num(l.final_price) : op;
      var cmp = num(l.compare_at);
      if (cmp > op) pack += (cmp - op) * q;
      var ca = codeAlloc(l);
      codeLine += ca;
      if (op > fp) line += Math.max(0, (op - fp) * q - ca);
    });
    var sub = subtotal(cart);
    var order = 0, live = false;
    if (num(cart && cart.cart_disc) > 0) { order = num(cart.cart_disc); live = true; }
    else if (codeLine > 0) { order = codeLine; live = true; }
    else if (codeInCart(cart) && sub >= num(D.threshold)) { order = Math.round(sub * num(D.percent) / 100); live = true; }
    else if (D.enabled && num(D.threshold) > 0 && sub >= num(D.threshold)) order = Math.round(sub * num(D.percent) / 100);
    var total = pack + line + gift + order;
    var full = sub + pack + line + gift;
    return { pack: pack, line: line, gift: gift, order: order, live: live, total: total, pct: full > 0 ? Math.round(total / full * 100) : 0, sub: sub };
  }
  ZP.savings = savings;

  function bankTip() {
    if (!C.bank) return '';
    return '<p class="zp-save__tip">\uD83C\uDFE6 Pay by <b>bank transfer</b> at checkout for FREE delivery' + (num(C.codFee) > 0 ? ' and save ' + money(C.codFee) + ' COD charges' : '') + '.</p>';
  }

  function savingsHTML(cart) {
    var sv = savings(cart);
    if (sv.total <= 0) return '';
    var rows = '';
    if (sv.pack > 0) rows += '<li><span>Pack &amp; bundle savings</span><b>-' + money(sv.pack) + '</b></li>';
    if (sv.line > 0) rows += '<li><span>Product discounts</span><b>-' + money(sv.line) + '</b></li>';
    if (sv.gift > 0) rows += '<li><span>Free gift (worth ' + money(sv.gift) + ')</span><b>FREE</b></li>';
    if (sv.order > 0) rows += '<li><span>' + num(D.percent) + '% order discount' + (sv.live ? (D.code ? ' (' + esc(D.code) + ' applied)' : ' (applied)') : ' (at checkout)') + '</span><b>-' + money(sv.order) + '</b></li>';
    return '<div class="zp-save"><p class="zp-save__h"><span>\uD83C\uDF89 You\u2019re saving <b>' + money(sv.total) + '</b> on this order</span>' +
      (sv.pct > 0 ? '<span class="zp-save__pct">' + sv.pct + '% OFF</span>' : '') + '</p><ul class="zp-save__rows">' + rows + '</ul></div>';
  }

  function footHTML(cart) {
    var sv = savings(cart);
    if (sv.total <= 0) return '';
    return '<span>\uD83C\uDF89 Total savings ' + money(sv.total) + (sv.pct > 0 ? ' (' + sv.pct + '% OFF)' : '') + '</span>' +
      (sv.order > 0 ? '<small>incl. ' + num(D.percent) + '% OFF' + (sv.live ? ' (shown at checkout)' : ' at checkout') + '</small>' : '');
  }

  // product page: every offer for the pack being viewed, live
  function renderPackOffers() {
    var el = $('[data-zp-pack-offers]');
    if (!el) return;
    var sel = num(el.getAttribute('data-sel'));
    var f = mainForm(), q = f && f.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
    var total = sel * qty + subtotal(S.cart);
    var chips = [];
    if (giftOn()) {
      var gt = num(G.threshold);
      chips.push(total >= gt ? '<span class="zp-po is-ok">\uD83C\uDF81 Free gift unlocked</span>'
        : '<span class="zp-po">\uD83C\uDF81 Free gift over ' + money(gt) + ' &middot; add ' + money(gt - total) + '</span>');
    }
    if (D.enabled && num(D.threshold) > 0) {
      var dt = num(D.threshold);
      chips.push(total >= dt ? '<span class="zp-po is-ok">\uD83C\uDFF7\uFE0F Extra ' + num(D.percent) + '% OFF unlocked</span>'
        : '<span class="zp-po">\uD83C\uDFF7\uFE0F Extra ' + num(D.percent) + '% OFF over ' + money(dt) + '</span>');
    }
    if (C.bank) chips.push('<span class="zp-po">\uD83C\uDFE6 Bank transfer: FREE delivery</span>');
    var html = chips.join('');
    if (el.__h !== html) { el.innerHTML = html; el.__h = html; }
  }
  ZP.renderPackOffers = renderPackOffers;

  ZP.ui = { giftOptions: giftOptions, bar: bar, fill: fill, GIFT_SVG: GIFT_SVG, TAG_SVG: TAG_SVG, LOCK_SVG: LOCK_SVG };
  ZP.store = store;

  function panelHTML(mode) {
    var cart = S.cart || { items: [] };
    var sub = subtotal(cart);
    if (mode === 'foot') return footHTML(cart);
    var html = savingsHTML(cart);
    var compact = mode === 'drawer';

    if (giftOn()) {
      var thr = num(G.threshold);
      var ok = sub >= thr;
      var gl = giftLines(cart)[0];
      var msg = ok ? esc(G.unlocked) : fill(esc(G.locked), { amount: '<b>' + money(thr - sub) + '</b>' });
      html += '<div class="zp-offer zp-offer--gift' + (ok ? ' is-ok' : '') + '">' +
        '<div class="zp-offer__row"><span class="zp-offer__ic">' + GIFT_SVG + '</span><span class="zp-offer__msg">' + msg + '</span></div>' +
        (ok ? '' : bar(sub / thr * 100)) +
        (ok ? '<p class="zp-offer__h">' + esc(G.heading) + '</p>' : '') +
        giftOptions('zp-gift-' + mode, gl ? gl.variant_id : '', !ok, compact) +
        '</div>';
    }
    if (D.enabled && num(D.threshold) > 0) {
      var dthr = num(D.threshold), dok = sub >= dthr, pct = num(D.percent);
      var saving = money(num(cart.cart_disc) > 0 ? num(cart.cart_disc) : Math.round(sub * pct / 100));
      var dmsg = dok
        ? fill(esc(D.unlocked), { percent: pct, saving: '<b>' + saving + '</b>' })
        : fill(esc(D.locked), { amount: '<b>' + money(dthr - sub) + '</b>', percent: pct });
      html += '<div class="zp-offer zp-offer--disc' + (dok ? ' is-ok' : '') + '">' +
        '<div class="zp-offer__row"><span class="zp-offer__ic">' + TAG_SVG + '</span><span class="zp-offer__msg">' + dmsg + '</span></div>' +
        (dok ? (num(cart.cart_disc) > 0 || codeInCart(cart) ? '<p class="zp-offer__note">Applied to your cart' + (D.code ? ' (code <b>' + esc(D.code) + '</b>)' : '') + ' and shown at checkout.</p>' : (D.code ? '<p class="zp-offer__note">Code <b>' + esc(D.code) + '</b> is added for you at checkout.</p>' : '<p class="zp-offer__note">Applied automatically at checkout.</p>')) : bar(sub / dthr * 100)) +
        '</div>';
    }
    return html + bankTip();
  }

  function renderPanels() {
    var count = (S.cart && S.cart.item_count) || 0;
    $$('[data-zimshy-offers]').forEach(function (el) {
      var mode = el.getAttribute('data-zimshy-offers') || 'drawer';
      if (!count) { el.hidden = true; el.innerHTML = ''; return; }
      var html = panelHTML(mode);
      el.hidden = !html;
      if (el.__zpHtml !== html) { el.innerHTML = html; el.__zpHtml = html; }
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.name || t.name.indexOf('zp-gift-') !== 0) return;
    if (t.closest('[data-zp-gift-picker]')) return; // product page picker has its own handler
    var box = t.closest('[data-zimshy-offers]');
    if (box) box.classList.add('is-busy');
    ZP.chooseGift(t.value).then(function () { if (box) box.classList.remove('is-busy'); });
  });

  /* ------------------------------------------- product page gift picker */
  var PK = { el: null, variants: {}, choice: null, eligible: false, timer: null, lastKey: '' };

  function mainForm() {
    var forms = $$('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].classList.contains('fbt_frm')) continue;
      if (forms[i].closest('[data-zp-routine-builder]')) continue;
      if (forms[i].querySelector('[name="id"]')) return forms[i];
    }
    return null;
  }

  function pickerState() {
    var f = mainForm();
    var idEl = f && f.querySelector('[name="id"]');
    var qEl = f && f.querySelector('[name="quantity"]');
    var vid = idEl ? String(idEl.value) : '';
    var v = PK.variants[vid] || PK.variants[Object.keys(PK.variants)[0]] || { p: 0 };
    var qty = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
    return { vid: vid, price: num(v.p) * qty, qty: qty };
  }

  function renderPicker(force) {
    if (!PK.el || !giftOn()) return;
    var st = pickerState();
    var cartSub = subtotal(S.cart);
    var thr = num(G.threshold);
    var total = st.price + cartSub;
    var ok = total >= thr;
    var gl = giftLines(S.cart)[0];
    if (gl) PK.choice = String(gl.variant_id);
    if (!PK.choice || !giftById(PK.choice)) {
      var saved = store.get('choice');
      PK.choice = saved && giftById(saved) ? saved : (G.preselect && G.items[0] ? String(G.items[0].vid) : null);
    }
    var key = [st.vid, st.qty, cartSub, ok, PK.choice, gl ? gl.variant_id : ''].join('|');
    if (!force && key === PK.lastKey) return;
    PK.lastKey = key;
    PK.eligible = ok;

    var tip = '';
    if (!ok) {
      // Point to the smallest pack that unlocks the gift on its own, if any.
      var best = null;
      Object.keys(PK.variants).forEach(function (id) {
        var v = PK.variants[id];
        if (!v.a) return;
        if (num(v.p) + cartSub >= thr && (!best || num(v.p) < num(best.p))) best = v;
      });
      if (best) tip = '<p class="zp-pick__tip">Tip: choose <b>' + esc(best.t) + '</b> and the gift is yours.</p>';
    }
    var head = ok
      ? '<span class="zp-chip zp-chip--ok">Unlocked</span>'
      : '<span class="zp-chip">' + LOCK_SVG + ' Locked</span>';
    var msg = ok
      ? (gl ? 'Your free gift is in the cart. You can change it below.' : esc(G.unlocked))
      : fill(esc(G.locked), { amount: '<b>' + money(thr - total) + '</b>' });

    PK.el.innerHTML =
      '<div class="zp-pick' + (ok ? ' is-ok' : '') + '">' +
        '<div class="zp-pick__head"><span class="zp-offer__ic">' + GIFT_SVG + '</span><span class="zp-pick__title">' + esc(G.heading) + '</span>' + head + '</div>' +
        '<p class="zp-pick__msg">' + msg + '</p>' +
        (ok ? '' : bar(total / thr * 100)) + tip +
        giftOptions('zp-gift-pdp', PK.choice || '', !ok, false) +
        (ok && !gl ? '<p class="zp-pick__note">Your selected gift is added with this order.</p>' : '') +
      '</div>';
  }

  function initPicker() {
    PK.el = $('[data-zp-gift-picker]');
    if (!PK.el || !giftOn()) { if (PK.el) PK.el.hidden = true; return; }
    try { PK.variants = JSON.parse(PK.el.getAttribute('data-variants') || '{}'); } catch (e) { PK.variants = {}; }
    PK.el.hidden = false;
    PK.lastKey = '';
    renderPicker(true);
    if (PK.el.__zpBound) return;
    PK.el.__zpBound = true;

    PK.el.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      PK.choice = String(t.value);
      store.set('choice', PK.choice);
      store.del('declined');
      var gl = giftLines(S.cart)[0];
      if (gl && String(gl.variant_id) !== PK.choice) {
        PK.el.classList.add('is-busy');
        ZP.chooseGift(PK.choice).then(function () { PK.el.classList.remove('is-busy'); renderPicker(true); });
      } else renderPicker(true);
    });

    if (PK.bound) return; // document level listeners only once
    PK.bound = true;

    // Follow pack / quantity changes. Polling only while the picker is on screen.
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { rootMargin: '200px' }).observe(PK.el);
    }
    PK.timer = setInterval(function () { if (visible && !document.hidden && PK.el && document.body.contains(PK.el)) renderPicker(false); }, 500);
    document.addEventListener('change', function () { setTimeout(function () { renderPicker(false); }, 30); }, true);

    var ATC = '.single_add_to_cart_button, .js_frm_cart, [name="add"], .sticky_atc_js, .sticky_atc_btn, .sticky_atc_a';
    var BUY = '.shopify-payment-button__button, .btn_buy_now, .js_btn_buy_now';

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !giftOn()) return;
      if (t.closest('[data-zp-routine-builder]')) return;
      renderPicker(false);
      var buy = t.closest(BUY);
      var atc = !buy && t.closest(ATC);
      if (!buy && !atc) return;
      if (!PK.eligible || !PK.choice || !giftById(PK.choice)) return;
      if (giftLines(S.cart).length && String(giftLines(S.cart)[0].variant_id) === PK.choice) return; // already there

      if (atc) { ZP.setPending(PK.choice); return; } // theme adds the product, the engine adds the gift right after

      // Buy it now skips the cart, so add product + gift to the cart and go to checkout ourselves.
      var f = mainForm();
      var idEl = f && f.querySelector('[name="id"]');
      if (!idEl) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (buy.classList.contains('is-zp-busy')) return;
      buy.classList.add('is-zp-busy');
      var st = pickerState();
      ZP.setPending(PK.choice);
      ZP.addItems([{ id: Number(idEl.value), quantity: st.qty }])
        .then(function () { return ZP.reconcile(); })
        .then(function (cart) { goCheckout(cart); })
        .catch(function (err) {
          buy.classList.remove('is-zp-busy');
          toast(err && err.message ? err.message : 'Could not start checkout. Please try again.', 'err');
        });
    }, true);
  }

  /* ---------------------------------------------- checkout + discount code */
  function discountEligible(cart) {
    return !!(D.enabled && D.code && subtotal(cart || S.cart) >= num(D.threshold));
  }
  function goCheckout(cart) {
    var url = ROOT + 'checkout';
    if (discountEligible(cart)) url += '?discount=' + encodeURIComponent(D.code);
    window.location.href = url;
  }
  ZP.goCheckout = goCheckout;
  ZP.mainForm = mainForm;

  function applyCode(form) {
    if (!form || !discountEligible()) return;
    var inp = form.querySelector('[name="discount"]');
    if (inp) { if (!String(inp.value || '').trim()) inp.value = D.code; return; }
    inp = document.createElement('input');
    inp.type = 'hidden'; inp.name = 'discount'; inp.value = D.code;
    form.appendChild(inp);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !D.code) return;
    var btn = t.closest('[name="checkout"], .btn-checkout, .btn_checkout');
    if (btn && btn.form) { applyCode(btn.form); return; }
    var a = t.closest('a[href]');
    if (a && /\/checkout(\?|$)/.test(a.getAttribute('href')) && discountEligible()) {
      e.preventDefault();
      goCheckout();
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.querySelector && f.querySelector('[name="checkout"]')) applyCode(f);
  }, true);

  /* --------------------------------------------------------- carousels */
  function initCarousel(el) {
    if (el.__zp) return; el.__zp = 1;
    var track = $('[data-zp-track]', el);
    if (!track) return;
    var prev = $('[data-zp-prev]', el), next = $('[data-zp-next]', el), prog = $('[data-zp-progress] span', el);
    var auto = num(el.getAttribute('data-zp-autoplay'));
    var hover = false, touched = false, onScreen = false, timer = null;

    function step() {
      var c = track.children[0];
      if (!c) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var w = c.getBoundingClientRect().width + gap;
      return Math.max(w, Math.floor(track.clientWidth / w) * w);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var x = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      el.classList.toggle('is-static', max <= 2);
      if (prog) {
        var vis = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        prog.style.width = (Math.max(vis, 0.08) * 100).toFixed(1) + '%';
        prog.style.transform = 'translateX(' + (max > 0 ? (x / max) * ((1 / Math.max(vis, 0.08)) - 1) * 100 : 0).toFixed(1) + '%)';
      }
    }
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth;
      if (dir > 0 && track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { touched = true; go(-1); });
    if (next) next.addEventListener('click', function () { touched = true; go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    el.addEventListener('mouseenter', function () { hover = true; });
    el.addEventListener('mouseleave', function () { hover = false; });
    track.addEventListener('touchstart', function () { touched = true; }, { passive: true });
    el.addEventListener('focusin', function () { touched = true; });

    // drag with the mouse on desktop
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, input, audio, a.zp-no-drag')) return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      setTimeout(function () { track.classList.remove('is-drag'); }, 0);
      if (moved) touched = true;
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    if (auto > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { onScreen = en[0].isIntersecting; }).observe(el);
      } else onScreen = true;
      timer = setInterval(function () {
        if (onScreen && !hover && !touched && !document.hidden && !el.querySelector('.is-playing')) go(1);
      }, auto * 1000);
    }
    update();
  }

  /* -------------------------------------------------------- voice notes */
  var playing = null;
  function fmtTime(s) {
    s = Math.max(0, Math.round(num(s)));
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }
  function seedBars(wave, seed) {
    if (wave.children.length) return;
    var h = 0, i, html = '';
    for (i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
    for (i = 0; i < 34; i++) {
      h = (h * 1103515245 + 12345) >>> 0;
      var v = 22 + (h % 78);
      if (i < 3 || i > 30) v = Math.min(v, 40);
      html += '<i style="height:' + v + '%"></i>';
    }
    wave.innerHTML = html;
  }
  function initVoice(el) {
    if (el.__zp) return; el.__zp = 1;
    var src = el.getAttribute('data-src');
    var btn = $('.zp-voice__play', el), wave = $('.zp-voice__wave', el), time = $('.zp-voice__time', el), sp = $('.zp-voice__speed', el);
    if (!src || !btn) return;
    if (wave) seedBars(wave, src);
    var audio = null, rate = 1;

    var bars = null, lastK = -1;
    function setP(p) {
      if (!wave) return;
      bars = bars || wave.children;
      var k = Math.round(p * bars.length);
      if (k === lastK) return;
      lastK = k;
      for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('on', i < k);
    }
    function ensure() {
      if (audio) return audio;
      audio = new Audio();
      audio.preload = 'metadata';
      audio.src = src;
      audio.addEventListener('loadedmetadata', function () { if (time && isFinite(audio.duration)) time.textContent = fmtTime(audio.duration); });
      audio.addEventListener('timeupdate', function () {
        if (!audio.duration) return;
        setP(audio.currentTime / audio.duration);
        if (time) time.textContent = fmtTime(audio.currentTime);
      });
      audio.addEventListener('play', function () { el.classList.add('is-playing'); btn.setAttribute('aria-label', 'Pause voice review'); });
      audio.addEventListener('pause', function () { el.classList.remove('is-playing'); btn.setAttribute('aria-label', 'Play voice review'); });
      audio.addEventListener('ended', function () { setP(0); if (time && isFinite(audio.duration)) time.textContent = fmtTime(audio.duration); });
      audio.addEventListener('waiting', function () { el.classList.add('is-loading'); });
      audio.addEventListener('playing', function () { el.classList.remove('is-loading'); });
      audio.addEventListener('error', function () { el.classList.remove('is-loading', 'is-playing'); toast('This voice note could not be played.', 'err'); });
      return audio;
    }
    btn.addEventListener('click', function () {
      var a = ensure();
      if (a.paused) {
        if (playing && playing !== a) playing.pause();
        playing = a;
        a.playbackRate = rate;
        var pr = a.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else a.pause();
    });
    if (wave) wave.addEventListener('click', function (e) {
      var a = ensure();
      var r = wave.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      var seek = function () { if (a.duration) { a.currentTime = p * a.duration; setP(p); } };
      if (a.readyState >= 1) seek(); else a.addEventListener('loadedmetadata', seek, { once: true });
    });
    if (sp) sp.addEventListener('click', function () {
      rate = rate === 1 ? 1.5 : rate === 1.5 ? 2 : 1;
      sp.textContent = rate + 'x';
      if (audio) audio.playbackRate = rate;
    });
  }

  /* ----------------------------------------------------------- lightbox */
  var LB = null;
  function openLightbox(list, index) {
    if (!LB) {
      LB = document.createElement('div');
      LB.className = 'zp-lb';
      LB.setAttribute('role', 'dialog');
      LB.setAttribute('aria-modal', 'true');
      LB.setAttribute('aria-label', 'Review screenshot');
      LB.innerHTML = '<button type="button" class="zp-lb__x" aria-label="Close">&times;</button>' +
        '<button type="button" class="zp-lb__nav zp-lb__prev" aria-label="Previous">&#8249;</button>' +
        '<figure class="zp-lb__fig"><img alt=""><figcaption></figcaption></figure>' +
        '<button type="button" class="zp-lb__nav zp-lb__next" aria-label="Next">&#8250;</button>';
      document.body.appendChild(LB);
      LB.addEventListener('click', function (e) {
        if (e.target === LB || e.target.classList.contains('zp-lb__x')) close();
        else if (e.target.classList.contains('zp-lb__prev')) show(LB.i - 1);
        else if (e.target.classList.contains('zp-lb__next')) show(LB.i + 1);
      });
      document.addEventListener('keydown', function (e) {
        if (!LB.classList.contains('is-on')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(LB.i - 1);
        if (e.key === 'ArrowRight') show(LB.i + 1);
      });
      var sx = null;
      LB.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      LB.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 50) show(LB.i + (dx < 0 ? 1 : -1));
      });
    }
    function show(i) {
      var n = LB.list.length;
      LB.i = (i + n) % n;
      var it = LB.list[LB.i];
      var img = $('img', LB);
      img.src = it.href; img.alt = it.alt || '';
      $('figcaption', LB).textContent = it.alt || '';
      $('.zp-lb__prev', LB).hidden = $('.zp-lb__next', LB).hidden = n < 2;
    }
    function close() {
      LB.classList.remove('is-on');
      document.documentElement.classList.remove('zp-noscroll');
      if (LB.opener) LB.opener.focus();
    }
    LB.list = list;
    LB.opener = document.activeElement;
    show(index);
    LB.classList.add('is-on');
    document.documentElement.classList.add('zp-noscroll');
    $('.zp-lb__x', LB).focus();
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('[data-zp-lb]');
    if (!a || a.__zpMoved) return;
    e.preventDefault();
    var group = a.closest('[data-zp-lb-group]') || document;
    var items = $$('[data-zp-lb]', group);
    openLightbox(items.map(function (x) { return { href: x.getAttribute('href'), alt: x.getAttribute('data-caption') || '' }; }), items.indexOf(a));
  });

  /* ---------------------------------------------------------- countdown */
  function initCountdown(el) {
    if (el.__zp) return; el.__zp = 1;
    var end = Date.parse(el.getAttribute('data-end') || '');
    if (!end) { el.hidden = true; return; }
    var parts = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (!left) {
        el.classList.add('is-ended');
        var ended = el.closest('[data-zp-countdown-wrap]');
        if (ended) ended.classList.add('is-ended');
        clearInterval(t);
      }
      var s = Math.floor(left / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(parts).forEach(function (k) { if (parts[k]) parts[k].textContent = ('0' + v[k]).slice(-2); });
    }
    var t = null;
    tick();
    if (!el.classList.contains('is-ended')) t = setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------- quick add */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-zp-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-busy')) return;
    var sel = b.getAttribute('data-zp-select') ? $(b.getAttribute('data-zp-select')) : null;
    var vid = sel ? sel.value : b.getAttribute('data-zp-add');
    if (!vid) return;
    b.classList.add('is-busy');
    ZP.addItems([{ id: Number(vid), quantity: Math.max(1, num(b.getAttribute('data-qty')) || 1) }])
      .then(function () { return ZP.reconcile(); })
      .then(function () {
        b.classList.remove('is-busy');
        b.classList.add('is-added');
        setTimeout(function () { b.classList.remove('is-added'); }, 2200);
        refreshTheme();
        openCart();
      })
      .catch(function (err) {
        b.classList.remove('is-busy');
        toast(err && err.message ? err.message : 'Could not add to cart.', 'err');
      });
  });

  // deal card option select: keep the shown price in sync
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('zpd-card__sel')) return;
    var o = t.options[t.selectedIndex], card = t.closest('.zpd-card');
    if (!o || !card) return;
    var now = $('[data-zpd-now]', card), was = $('[data-zpd-was]', card);
    if (now) now.textContent = o.getAttribute('data-p') || '';
    if (was) was.textContent = o.getAttribute('data-c') || '';
  });

  /* -------------------------------------------------------------- copy */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-zp-copy]');
    if (!b) return;
    e.preventDefault();
    var txt = b.getAttribute('data-zp-copy');
    var done = function () {
      b.classList.add('is-copied');
      var o = b.getAttribute('data-label') || b.textContent;
      b.setAttribute('data-label', o);
      b.textContent = 'Copied';
      setTimeout(function () { b.textContent = o; b.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(txt).then(done, function () { fallback(); });
    else fallback();
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (err) { toast(txt); }
      document.body.removeChild(ta);
    }
  });

  /* ---------------------------------------------------- lazy component init */
  var INITS = [
    ['[data-zp-carousel]', initCarousel],
    ['[data-zp-voice]', initVoice],
    ['[data-zp-countdown]', initCountdown]
  ];
  function initAll(ctx) {
    INITS.forEach(function (p) { $$(p[0], ctx).forEach(function (el) { lazy(el, p[1]); }); });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (x) {
      if (!x.isIntersecting) return;
      io.unobserve(x.target);
      var f = x.target.__zpInit; x.target.__zpInit = null;
      if (f) f(x.target);
    });
  }, { rootMargin: '300px 0px' }) : null;
  function lazy(el, fn) {
    if (el.__zp || el.__zpInit) return;
    if (!io) { fn(el); return; }
    el.__zpInit = fn;
    io.observe(el);
  }
  ZP.initAll = initAll;

  /* --------------------------------------------------------------- boot */
  function boot() {
    bindJq();
    initAll(document);
    initPicker();
    renderPanels();
    renderPackOffers();
    document.addEventListener('change', function () { setTimeout(renderPackOffers, 40); }, true);

    // Validate gifts on load only when needed (keeps pages request-free otherwise)
    var gl = giftLines(S.cart);
    var needs = gl.length && (subtotal(S.cart) < num(G.threshold) || gl.length > 1 || gl[0].quantity > 1);
    if (!needs && giftOn() && !gl.length && G.readd && store.get('auto_removed') && !store.get('declined') && store.get('choice') && subtotal(S.cart) >= num(G.threshold)) needs = true;
    if (!needs && D.enabled && D.code && S.cart && S.cart.codes) {
      var lc0 = String(D.code).toLowerCase(), has0 = S.cart.codes.some(function (c) { return String(c.code).toLowerCase() === lc0; });
      var ok0 = S.cart.item_count > 0 && subtotal(S.cart) >= num(D.threshold);
      if ((ok0 && !has0 && !S.cart.codes.length) || (!ok0 && has0)) needs = true;
    }
    if (needs) ZP.reconcile();

    // Back/forward cache: refresh cart state instead of reloading the whole page
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (C.page === 'cart') { window.location.reload(); return; }
      ZP.reconcile().then(function (c) {
        var shown = $('.jsccount');
        if (shown && String(c.item_count) !== shown.textContent.trim()) refreshTheme();
      });
    });
    var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward' && C.page !== 'cart') {
      ZP.reconcile().then(function (c) {
        var shown = $('.jsccount');
        if (shown && String(c.item_count) !== shown.textContent.trim()) refreshTheme();
      });
    }
    window.addEventListener('load', bindJq);

    // Theme editor: re-init sections when they are added or changed
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initPicker(); renderPanels(); });
  }
  ZP.renderPanels = renderPanels;
  function render() { renderPanels(); renderPicker(true); renderPackOffers(); document.dispatchEvent(new CustomEvent('zp:cart', { detail: S.cart })); }
  ZP.render = render;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
